// @flow

export const fees = {
  standardFee: '225',
}

export default fees
